/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkDetailDto } from '../../models/benchmark-detail-dto';
import { CreateBenchmarkCommand } from '../../models/create-benchmark-command';

export interface ApiAdminBenchmarksPost$Params {
      body?: CreateBenchmarkCommand
}

export function apiAdminBenchmarksPost(http: HttpClient, rootUrl: string, params?: ApiAdminBenchmarksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkDetailDto>;
    })
  );
}

apiAdminBenchmarksPost.PATH = '/api/Admin/benchmarks';
